<template>
  <div>
    <b-row class="mb-3">
      <b-col>
        <b-input
          v-model="searchText"
          debounce="500"
          trim
          size="sm"
          placeholder="search..."
        ></b-input>
        <small class="text-muted"
          >If not found, it means that there is no manual settings for the
          measure.</small
        >
        <small class="text-muted">It will be using the default values.</small>
      </b-col>
      <b-col cols="3">
        <b-button
          size="sm"
          variant="outline-primary"
          class="d-inline-block ml-3"
          @click="addMeasure"
        >
          Add
        </b-button>
      </b-col>
    </b-row>
    <b-list-group>
      <b-list-group-item
        v-for="measure in filteredMeasures"
        :key="measure.id"
        @click="loadMeasure(measure)"
        class="dashboard-list-item"
      >
        <b-row>
          <b-col>
            <span>
              {{ measure.measureCaption }}
            </span>
          </b-col>
          <b-col cols="3" sm="2" lg="1">
            <b-badge variant="secondary" v-if="measure.isHidden"
              >Hidden
            </b-badge>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <small class="text-muted">{{ measure.measureId }}</small>
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>

    <b-modal
      v-model="formModal"
      centered
      hide-header
      size="lg"
      button-size="sm"
      ok-title="Submit"
      @ok="submit"
    >
      <b-row class="mb-3">
        <b-col>
          <b-button
            size="sm"
            variant="outline-danger"
            @click="deleteMeasure"
            class="float-right"
            >Delete
          </b-button>
        </b-col>
      </b-row>
      <b-form ref="main-form">
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Measure Unique Name</div>
          </b-col>
          <b-col>
            <b-form-input
              v-model="formItems.measureId"
              placeholder="[Measures].[Bet Count]"
              size="sm"
              autofocus
              trim
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Measure Caption</div>
          </b-col>
          <b-col>
            <b-form-input
              v-model="formItems.measureCaption"
              placeholder="Bet Count"
              size="sm"
              trim
              required
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Measure Format</div>
            <div>
              <small class="text-muted">
                Will display measure in these format
              </small>
            </div>
          </b-col>
          <b-col>
            <b-select
              v-model="formItems.measureFormat"
              size="sm"
              :options="formats"
              required
            ></b-select>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">Hidden?</b-col>
          <b-col>
            <b-form-checkbox
              v-model="formItems.isHidden"
              :value="true"
              :unchecked-value="false"
            ></b-form-checkbox>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash';
import notification from '@/mixins/notification';
import adminServices from '../../services/adminServices';

export default {
  name: 'MeasureConfigs',
  props: ['cubeId'],
  mixins: [notification],
  mounted() {
    this.getList();
  },
  computed: {
    filteredMeasures() {
      const searchText = this.searchText.toLowerCase();
      let filteredMeasures = _.filter(this.measures, {
        cubeConfigId: this.cubeId,
      });
      filteredMeasures = _.filter(filteredMeasures, measure => {
        return measure.measureId.toLowerCase().includes(searchText);
      });
      return filteredMeasures;
    },
  },
  data() {
    return {
      measures: [],
      formItems: defaultFormItems(),

      formats: [
        { value: 'INTEGER', text: 'Integer' },
        { value: 'MONEY', text: 'Money' },
        { value: 'PERCENTAGE', text: 'Percentage' },
        { value: 'DECIMAL', text: 'Decimal' },
      ],
      searchText: '',
      formModal: false,
      isEdit: false,
    };
  },
  methods: {
    getList() {
      adminServices.getMeasureConfigs().then(resp => {
        this.measures = resp.data;
      });
    },
    loadMeasure(measure) {
      this.isEdit = true;
      this.formItems = {
        ..._.cloneDeep(measure),
        ...{ cubeConfigId: this.cubeId },
      };
      this.formModal = true;
    },
    addMeasure() {
      this.isEdit = false;
      this.formItems = {
        ...defaultFormItems(),
        ...{ cubeConfigId: this.cubeId },
      };
      this.formModal = true;
    },
    deleteMeasure() {
      this.$bvModal
        .msgBoxConfirm('Proceed to delete setting?', { centered: true })
        .then(value => {
          if (value) {
            this.formModal = false;
            adminServices.deleteMeasureConfigs(this.formItems.id).then(() => {
              this.PromptSuccess(
                'Success',
                'Setting had been deleted successfully.'
              );
              this.measures = _.filter(
                this.measures,
                measure => measure.id !== this.formItems.id
              );
            });
          }
        });
    },
    submit(e) {
      e.preventDefault();
      const mainForm = this.$refs['main-form'];
      if (!mainForm.reportValidity()) {
        return;
      }
      const formItems = _.cloneDeep(this.formItems);
      if (this.isEdit) {
        this.$bvModal
          .msgBoxConfirm('Proceed to edit setting?', { centered: true })
          .then(value => {
            if (value) {
              this.formModal = false;
              adminServices.putMeasureConfigs(formItems).then(() => {
                this.PromptSuccess(
                  'Success',
                  'Setting had been updated successfully.'
                );
                let measures = _.filter(
                  this.measures,
                  measure => measure.id !== formItems.id
                );
                measures.push(formItems);
                this.measures = measures;
              });
            }
          });
      } else {
        this.$bvModal
          .msgBoxConfirm('Proceed to add setting?', { centered: true })
          .then(value => {
            if (value) {
              this.formModal = false;
              adminServices.postMeasureConfigs(formItems).then(resp => {
                this.PromptSuccess(
                  'Success',
                  'Setting had been added successfully.'
                );
                this.measures.push(resp.data);
              });
            }
          });
      }
    },
  },
};

const defaultFormItems = () => {
  return {
    measureId: '',
    measureCaption: '',
    measureFormat: 'MONEY',
    isHidden: false,
    cubeConfigId: 1,
  };
};
</script>

<style scoped>
.dashboard-list-item {
  cursor: pointer;
}

.dashboard-list-item:hover {
  background-color: #ebebeb;
}
</style>